var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUser = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 5.5C12.067 5.5 10.5 7.067 10.5 9C10.5 10.933 12.067 12.5 14 12.5C15.933 12.5 17.5 10.933 17.5 9C17.5 7.067 15.933 5.5 14 5.5ZM9.5 9C9.5 6.51472 11.5147 4.5 14 4.5C16.4853 4.5 18.5 6.51472 18.5 9C18.5 11.4853 16.4853 13.5 14 13.5C11.5147 13.5 9.5 11.4853 9.5 9ZM6.81802 17.818C7.66193 16.9741 8.80653 16.5 10 16.5H18C19.1935 16.5 20.3381 16.9741 21.182 17.818C22.0259 18.6619 22.5 19.8065 22.5 21V23C22.5 23.2761 22.2761 23.5 22 23.5C21.7239 23.5 21.5 23.2761 21.5 23V21C21.5 20.0717 21.1313 19.1815 20.4749 18.5251C19.8185 17.8687 18.9283 17.5 18 17.5H10C9.07174 17.5 8.1815 17.8687 7.52513 18.5251C6.86875 19.1815 6.5 20.0717 6.5 21V23C6.5 23.2761 6.27614 23.5 6 23.5C5.72386 23.5 5.5 23.2761 5.5 23V21C5.5 19.8065 5.97411 18.6619 6.81802 17.818Z",
    fill: "#111111"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user.b517eed6.svg";
export { ForwardRef as ReactComponent };